import {
  Box,
  IconButton,
  Button,
  Typography,
  MenuItem,
  Select,
  Grid,
  CardContent,
  Card,
  TextField,
  FormControl,
  InputLabel,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import { CheckCircleOutline } from "@mui/icons-material";
import { PlusOne } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import { Suspense, useEffect, useState, useRef } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import Header from "../../../components/Header";
import { useTheme } from "@mui/material";
import { gql, useQuery, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import swal from "sweetalert";
import { allSmsSettings } from "../../../data/Axios/queries";
import {
  companyManagementUrl,
  setupManagementUrl,
  smsservice,
} from "../../../config";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

function SmsSettings() {
  const theme = useTheme();
  const [smsData, setSmsData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(true);
  const [values, setValues] = useState({
    apiKey: "",
    SenderId: "",
    PartnerId: "",
    smsApiId: "",
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  useEffect(() => {
    async function fetchAllData() {
      try {
        const smsDataResponse = await graphqlQuery(
          allSmsSettings,
          smsservice.uri
        );
        if (smsDataResponse) {
          setSmsData(smsDataResponse);
          setValues({
            apiKey: smsDataResponse.apiKey || "",
            SenderId: smsDataResponse.senderId || "",
            PartnerId: smsDataResponse.partnerId || "",
            smsApiId: smsDataResponse.smsApiId || "",
          });
        }
        const smsapidata = await fetchJsonDynamic(
          "allSmsApis",
          null,
          null,
          setupManagementUrl.uri
        );
        if (smsapidata?.results) {
          const results = JSON.parse(smsapidata?.results);
          setData(results || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);

  const colors = tokens(theme.palette.mode);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        partnerId: values.PartnerId,
        apiKey: values.apiKey,
        senderId: values.SenderId,
        smsApiId: values.smsApiId,
      };
      const response = await executeAnyMutation(
        "updateCompanySmsSettings",
        mutationData,
        "settings",
        false,
        companyManagementUrl.uri
      );

      if (Object.values(response?.results)) {
        // fetchAllData();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Company SMS Settings ${
            isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box m="20px">
      <Header title="SMS Settings" subtitle="Manage sms settings" />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "solid #70d8bd",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <Card
              sx={{
                minWidth: 275,
                border:
                  theme.palette.mode === "dark"
                    ? "1px solid #70d8bd"
                    : "1px solid #1F2A40",
                borderRadius: "0.75rem",
                bgcolor:
                  theme.palette.mode === "light"
                    ? colors.primary[900]
                    : colors.blueAccent[700],
              }}
            >
              <CardContent>
                <Typography
                  sx={{
                    fontSize: 14,
                    color: colors.greenAccent[400],
                  }}
                  gutterBottom
                >
                  Promotional Amount
                </Typography>
                <Typography variant="h5" component="div">
                  {smsData.promotionalAmount}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card
              sx={{
                minWidth: 275,
                border:
                  theme.palette.mode === "dark"
                    ? "1px solid #70d8bd"
                    : "1px solid #1F2A40",
                borderRadius: "0.75rem",
                bgcolor:
                  theme.palette.mode === "light"
                    ? colors.primary[900]
                    : colors.blueAccent[700],
              }}
            >
              <CardContent>
                <Typography
                  sx={{
                    fontSize: 14,
                    color: colors.greenAccent[400],
                  }}
                  gutterBottom
                >
                  Transactional Amount
                </Typography>
                <Typography variant="h5" component="div">
                  {smsData.transactionalAmount}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="apiKey"
              label="Api Key"
              variant="outlined"
              fullWidth
              value={values.apiKey}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="SenderId"
              label="SenderId"
              variant="outlined"
              fullWidth
              value={values.SenderId}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="PartnerId"
              label="Partner Id"
              variant="outlined"
              fullWidth
              value={values.PartnerId}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="sms-api-select-label">SMS API</InputLabel>
              <Select
                labelId="sms-api-select-label"
                id="smsApiId"
                name="smsApiId"
                value={values.smsApiId}
                label="SMS API"
                onChange={handleChange}
              >
                {data.map((api) => (
                  <MenuItem key={api.Id} value={api.Id}>
                    {api.Apiname}{" "}
                    {/* Assuming each API has a 'name' property */}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => handleSubmit(values, { setSubmitting: () => {} })}
            >
              Submit
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Card
              sx={{
                justifyContent: "center",
                minWidth: 275,
                border:
                  theme.palette.mode === "dark"
                    ? "1px solid #70d8bd"
                    : "1px solid #1F2A40",
                borderRadius: "0.75rem",
                bgcolor:
                  theme.palette.mode === "light"
                    ? colors.primary[900]
                    : colors.blueAccent[700],
              }}
            >
              {/* SMS Limit Card Content */}
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SmsSettings;
